import type { ReactNode } from 'react'
import styles from './Field.module.css'

type Props = {
	label: string
	// 'caption' is the uppercase micro-heading the recipe forms use; 'default'
	// is the plain muted label of the dialogs and sign-in.
	variant?: 'default' | 'caption'
	hint?: ReactNode
	error?: ReactNode
	children: ReactNode
}

// Label + control + optional hint/error. The control is styled by descendant
// selector rather than an exported class, so a call site is just
// `<Field label="Email"><input … /></Field>`.
//
// Overriding one of those defaults takes a doubled class — `.mine.mine { … }`
// — because `.field input` carries a type selector and so outweighs a single
// class. The two 5-digit code inputs are the only places that need it.
export const Field = ({
	label,
	variant = 'default',
	hint,
	error,
	children,
}: Props) => (
	<label className={styles.field}>
		<span
			className={
				variant === 'caption' ? styles.captionLabel : styles.label
			}
		>
			{label}
		</span>
		{children}
		{hint ? <span className={styles.hint}>{hint}</span> : null}
		{error ? <span className={styles.error}>{error}</span> : null}
	</label>
)
